import script from "./FormLogin.vue?vue&type=script&setup=true&lang=js"
export * from "./FormLogin.vue?vue&type=script&setup=true&lang=js"

import "./FormLogin.vue?vue&type=style&index=0&id=60418936&lang=css"

const __exports__ = script;

export default __exports__